import { Moment } from 'moment';
import * as Sentry from '@sentry/react';
import AES from 'crypto-js/aes';
import CryptoJSUtf8 from 'crypto-js/enc-utf8';

const accessTokenKey = 'accessToken';
const refreshTokenKey = 'conekto-refreshtoken';
const privateKey = 'jIwe9zWq&C^+SpaS';
interface LoginInfo {
  token: string;
  expiredTime: Moment;
  userId: string;
}
class AuthService {
  clearOnLogout = () => {
    localStorage.removeItem(accessTokenKey);
    localStorage.removeItem(refreshTokenKey);
  };
  getAccessToken = () => {
    try {
      const info: LoginInfo | null = JSON.parse(localStorage.getItem(accessTokenKey) || '');
      return info?.token;
    } catch (error) {
      return null;
    }
  };
  getLoginInfo = () => {
    try {
      const info: LoginInfo | null = JSON.parse(localStorage.getItem(accessTokenKey) || '');
      return info;
    } catch (error) {
      return null;
    }
  };
  saveLoginInfo = (info: LoginInfo) => {
    localStorage.setItem(accessTokenKey, JSON.stringify(info));
  };

  saveRefreshToken = (token: string) => {
    const ciphertext = AES.encrypt(token, privateKey).toString();
    localStorage.setItem(refreshTokenKey, ciphertext);
  };
  getRefreshToken = () => {
    try {
      const ciphertext = localStorage.getItem(refreshTokenKey);
      if (ciphertext) {
        const bytes = AES.decrypt(ciphertext, privateKey);
        return bytes.toString(CryptoJSUtf8);
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  logUserInfo2Sentry = (userId: string | undefined, email: string | undefined, username: string | undefined) => {
    Sentry.setUser({ id: userId, email: email, username: username });
  };
}

export default new AuthService();
